(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hotspot-launch"] && !Shopify.designMode) return;
  try {
    
function initHotspotInterest(){
document.querySelectorAll('.hl').forEach(root=>{
const interest=root.querySelector('[name="contact[interest]"]');
if(!interest||root.dataset.hlInitialized==='true')return;
root.dataset.hlInitialized='true';
const update=()=>root.querySelectorAll('[data-hl-topic]').forEach(group=>{
const show=interest.value==='Both'||(group.dataset.hlTopic==='fragrance'?interest.value==='Arabic body sprays':interest.value==='Used clothing wholesale');
group.hidden=!show;
group.disabled=!show;
});
interest.addEventListener('change',update);
root.querySelectorAll('a[href="#hl-interest"]').forEach(link=>link.addEventListener('click',()=>{
interest.value=link.closest('#hl-clothing')?'Used clothing wholesale':'Arabic body sprays';
update();
}));
update();
});
}
initHotspotInterest();
document.addEventListener('shopify:section:load',initHotspotInterest);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instant-w3X0JODLEcqe8Unw"]) return;
  try {
    
function initHotspotInterest(){
  document.querySelectorAll('.hotspot-focus-form').forEach(root=>{
    const interest=root.querySelector('[name="contact[interest]"]');
    if(!interest||root.dataset.hlInitialized==='true')return;
    root.dataset.hlInitialized='true';
    const update=()=>{
      const states=[['[data-hl-hair]',interest.value==='Hair extensions & bundles'],['[data-hl-procurement]',interest.value==='Government and institutional sourcing'],['[data-hl-topic="fragrance"]',interest.value==='Fragrance and body care'],['[data-hl-topic="clothing"]',interest.value==='Donation clothing']];
      states.forEach(([selector,show])=>{const group=root.querySelector(selector);if(group){group.hidden=!show;group.disabled=!show;}});
    };
    const requestedInterest=new URLSearchParams(window.location.search).get('interest');
    if(requestedInterest&&Array.from(interest.options).some(option=>option.value===requestedInterest))interest.value=requestedInterest;
    interest.addEventListener('change',update);
    const page=root.closest('.__instant');
    if(page)page.addEventListener('click',event=>{
      const link=event.target.closest('a[href="#hl-interest"]');
      if(!link||!page.contains(link))return;
      const value=link.dataset.buyerInterest||'General wholesale';
      if(Array.from(interest.options).some(option=>option.value===value))interest.value=value;
      if(link.dataset.clothingQuantity){
        const total=root.querySelector('#hl-quantity');
        if(total)total.value=link.dataset.clothingQuantity;
      }
      update();
    });
    update();
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initHotspotInterest,{once:true});else initHotspotInterest();
document.addEventListener('shopify:section:load',initHotspotInterest);

function initWholesaleVideoSound(){
document.querySelectorAll('.wholesale-range-video').forEach(container=>{
const video=container.querySelector('video');
const button=container.querySelector('.wholesale-video-sound');
if(video && video.dataset.autoplayReady !== 'true'){
video.dataset.autoplayReady='true';
video.defaultMuted=true;
video.muted=true;
video.autoplay=true;
video.loop=true;
video.playsInline=true;
video.removeAttribute('poster');
const startPlayback=()=>{
if(!video.paused)return;
const attempt=video.play();
if(attempt && typeof attempt.catch==='function')attempt.catch(()=>{});
};
video.addEventListener('loadeddata',startPlayback,{once:true});
if('IntersectionObserver' in window){
const observer=new IntersectionObserver(entries=>{
if(entries.some(entry=>entry.isIntersecting)){startPlayback();observer.disconnect();}
},{rootMargin:'160px'});
observer.observe(video);
}
startPlayback();
}
if(!video||!button||button.dataset.ready==='true')return;
button.dataset.ready='true';
button.addEventListener('click',()=>{
video.muted=!video.muted;
if(video.paused){const attempt=video.play();if(attempt)attempt.catch(()=>{});}
button.textContent=video.muted?'Tap for sound':'Sound on';
button.setAttribute('aria-label',video.muted?'Turn video sound on':'Mute video');
});
});
}
initWholesaleVideoSound();
document.addEventListener('shopify:section:load',initWholesaleVideoSound);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
